export default function FloatingWhatsApp() {
  const url =
    "https://wa.me/919928009559?text=" +
    encodeURIComponent(
      "Namaste Dr. Kalpana, I came across your website and would like to book a session."
    );

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="fab-wa"
      aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp"
    >
      <i className="fa-brands fa-whatsapp" style={{ position: "relative", zIndex: 2 }}></i>
    </a>
  );
}
